import { IGeoLocation } from '@msdyn365-commerce/core-internal';
import { IDictionary } from '@msdyn365-commerce/retail-proxy';
import { ITargetingData } from '../modules/mfrm-targetted-footer-disclaimer/mfrm-targetted-footer-disclaimer.props.autogenerated';

const isTargetingCriteriaMatched = (
    geoLocation: IGeoLocation | undefined,
    query: IDictionary<string> | undefined,
    targetingRule: ITargetingData | undefined
): Boolean => {
    let hasValidTargetedLocation = false;
    let queryResult = false;
    let hasKey = false;
    let hasValue = false;
    // targeting critieria doesn't exist return true and dispaly eyebrow message
    if (!targetingRule) {
        return true;
    }
    // if targeting critieria exists then do some business logic checks
    const hasState = targetingRule.state ? true : false;
    const hasCity = targetingRule.city ? true : false;
    const hasZipcode = targetingRule.zipCode ? true : false;
    const hasMetroCode = targetingRule.metroCode ? true : false;
    hasKey = targetingRule.sourceCode?.key ? true : false;
    hasValue = targetingRule.sourceCode?.value ? true : false;
    hasValidTargetedLocation = isValidTargetLocation(hasState, hasCity, hasZipcode, hasMetroCode, targetingRule, geoLocation);
    if (hasKey && hasValue && query) {
        Object.entries(query).forEach(([key, value]) => {
            if (
                key.toLowerCase() === targetingRule.sourceCode?.key?.toLowerCase() &&
                value.toLowerCase() === targetingRule.sourceCode?.value?.toLowerCase()
            ) {
                queryResult = true;
            }
        });
    }
    if (hasValidTargetedLocation && (queryResult || !(hasKey && hasValue))) {
        return true;
    }
    return false;
};

const isValidTargetLocation = (
    hasState: boolean,
    hasCity: boolean,
    hasZipcode: boolean,
    hasMetroCode: boolean,
    targetingRule: ITargetingData,
    geoLocation: IGeoLocation | undefined
) => {
    const state = targetingRule.state
        ?.toLowerCase()
        .split(',')
        ?.find(x => x.trim() === geoLocation?.region?.toLowerCase());
    const city = targetingRule.city
        ?.toLowerCase()
        .split(',')
        ?.find(x => x.trim() === geoLocation?.city?.toLowerCase());
    const zipCode = targetingRule.zipCode
        ?.toLowerCase()
        .split(',')
        ?.find(x => x.trim() === geoLocation?.zipCode?.toLowerCase());
    const metroCode = targetingRule.metroCode
        ?.toLowerCase()
        .split(',')
        ?.find(x => x.trim() === geoLocation?.metroCode?.toLowerCase());

    return (
        (hasState ? (state ? true : false) : true) &&
        (hasCity ? (city ? true : false) : true) &&
        (hasZipcode ? (zipCode ? true : false) : true) &&
        (hasMetroCode ? (metroCode ? true : false) : true)
    );
};

export default isTargetingCriteriaMatched;
